/** Ein Alias: der Name, unter dem die URLs des Operators einen Dataspace oder einen Prozess statt seiner ID nennen (`AliasField`). */
export default {
	alias: {
		label: "Alias",
		hint: "Optional. Ein kurzer Name, den seine URL statt der ID verwendet.",
		opens: "Seine URL: {path}",
		problem: {
			form: "Nur Buchstaben a bis z, Ziffern und Bindestriche",
			length: "Höchstens {max} Zeichen",
			id: "Ein Alias darf nicht wie eine ID aussehen",
			reserved: "„{alias}“ wird von der App verwendet und kann kein Alias sein",
		},
		taken: "Dieser Alias ist bereits vergeben",
	},
};
